import React from "react";

export const GoalItem = ({ index, titleGoal, desGoal }) => {
  return (
    <div key={index} className="goal-item">
      <h3> {titleGoal}</h3>
      <p>{desGoal}</p>
    </div>
  );
};
